import { ImageSizeResponseBuilder } from './ImageSizeResponseBuilder';
import { IBaseArgument } from './IBaseArgument';
import { BaseResponseBuilder } from './BaseResponseBuilder';

export class ImageResponseBuilder extends BaseResponseBuilder {
    constructor() {
        super('Image');
    }
    public withUrl = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['url'] = this.initField(null, args);
        return this;
    }

    public withImageType = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['imageType'] = this.initField(null, args);
        return this;
    }

    public withDescription = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['description'] = this.initField(null, args);
        return this;
    }

    public withImageSize = (builder: ImageSizeResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['imageSize'] = this.initField(builder, args);
        return this;
    }

    public withActivityId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['activityId'] = this.initField(null, args);
        return this;
    }

    public withSupplierId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['supplierId'] = this.initField(null, args);
        return this;
    }
}
